import { render, staticRenderFns } from "./VerticalSlider.vue?vue&type=template&id=53c45f27&scoped=true"
import script from "./VerticalSlider.vue?vue&type=script&lang=ts"
export * from "./VerticalSlider.vue?vue&type=script&lang=ts"
import style0 from "./VerticalSlider.vue?vue&type=style&index=0&id=53c45f27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c45f27",
  null
  
)

export default component.exports